import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-command-header" }
const _hoisted_2 = {
  id: "modal-command-title",
  class: "header-title"
}
const _hoisted_3 = ["aria-label", "disabled"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "modal-command-body" }
const _hoisted_6 = {
  key: 0,
  class: "error-banner",
  role: "alert"
}
const _hoisted_7 = { class: "error-banner-text" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = {
  key: 0,
  class: "recap-item"
}
const _hoisted_10 = { class: "recap-label" }
const _hoisted_11 = { class: "recap-value recap-bold" }
const _hoisted_12 = { class: "recap-item" }
const _hoisted_13 = { class: "recap-label" }
const _hoisted_14 = { class: "recap-value" }
const _hoisted_15 = {
  key: 1,
  class: "recap-item"
}
const _hoisted_16 = { class: "recap-label" }
const _hoisted_17 = { class: "recap-value recap-price" }
const _hoisted_18 = {
  key: 1,
  class: "section-container"
}
const _hoisted_19 = {
  class: "section-title",
  id: "choice-group-label"
}
const _hoisted_20 = {
  class: "choice-cards-container",
  role: "radiogroup",
  "aria-labelledby": "choice-group-label"
}
const _hoisted_21 = ["aria-checked"]
const _hoisted_22 = { class: "choice-radio-indicator" }
const _hoisted_23 = { class: "choice-text" }
const _hoisted_24 = { class: "choice-title" }
const _hoisted_25 = { class: "choice-desc" }
const _hoisted_26 = ["aria-checked"]
const _hoisted_27 = { class: "choice-radio-indicator" }
const _hoisted_28 = { class: "choice-text" }
const _hoisted_29 = { class: "choice-title" }
const _hoisted_30 = { class: "choice-desc" }
const _hoisted_31 = {
  key: 0,
  class: "signatory-section"
}
const _hoisted_32 = { class: "section-title" }
const _hoisted_33 = { class: "signatory-form" }
const _hoisted_34 = { class: "form-field" }
const _hoisted_35 = {
  for: "signatory-lastname",
  class: "field-label"
}
const _hoisted_36 = ["disabled", "aria-invalid", "aria-describedby"]
const _hoisted_37 = {
  key: 0,
  id: "signatory-lastname-error",
  class: "field-error-message",
  role: "alert"
}
const _hoisted_38 = { class: "form-field" }
const _hoisted_39 = {
  for: "signatory-firstname",
  class: "field-label"
}
const _hoisted_40 = ["disabled", "aria-invalid", "aria-describedby"]
const _hoisted_41 = {
  key: 0,
  id: "signatory-firstname-error",
  class: "field-error-message",
  role: "alert"
}
const _hoisted_42 = { class: "form-field" }
const _hoisted_43 = {
  for: "signatory-email",
  class: "field-label"
}
const _hoisted_44 = ["disabled", "aria-invalid", "aria-describedby"]
const _hoisted_45 = {
  id: "signatory-email-help",
  class: "field-help-message"
}
const _hoisted_46 = {
  key: 0,
  id: "signatory-email-error",
  class: "field-error-message",
  role: "alert"
}
const _hoisted_47 = {
  key: 2,
  class: "section-container without-sign-info"
}
const _hoisted_48 = { class: "order-info-grid" }
const _hoisted_49 = { class: "form-field" }
const _hoisted_50 = {
  for: "numero-commande-input",
  class: "field-label"
}
const _hoisted_51 = { class: "optional-mention" }
const _hoisted_52 = ["placeholder", "disabled"]
const _hoisted_53 = { class: "form-field" }
const _hoisted_54 = {
  class: "field-label",
  id: "bon-commande-label"
}
const _hoisted_55 = { class: "optional-mention" }
const _hoisted_56 = { class: "file-upload-wrapper" }
const _hoisted_57 = ["disabled", "aria-invalid", "aria-describedby"]
const _hoisted_58 = {
  key: 0,
  class: "file-action-row"
}
const _hoisted_59 = ["disabled"]
const _hoisted_60 = ["src"]
const _hoisted_61 = {
  key: 1,
  class: "file-selected-row"
}
const _hoisted_62 = {
  key: 0,
  id: "bon-commande-error",
  class: "field-error-message",
  role: "alert"
}
const _hoisted_63 = { class: "confirmation-mention" }
const _hoisted_64 = { class: "modal-command-footer" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = ["disabled"]
const _hoisted_67 = {
  key: 0,
  class: "loader-spinner",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioBox = _resolveComponent("RadioBox")!
  const _component_RemovableItem = _resolveComponent("RemovableItem")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onCancel: _ctx.cancel
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "modal-command-card",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "modal-command-title",
            tabindex: "-1",
            ref: "modalCard",
            onKeydown: _cache[22] || (_cache[22] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["stop","prevent"]), ["esc"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('devis.modal.command.title', { id: _ctx.id })), 1),
              _createElementVNode("button", {
                type: "button",
                class: "close-button",
                "aria-label": _ctx.$t('devis.modal.command.btn.cancel'),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
                disabled: _ctx.isLoading
              }, [
                _createElementVNode("img", {
                  class: "close-icon",
                  src: _ctx.closeIcon,
                  alt: "",
                  "aria-hidden": "true"
                }, null, 8, _hoisted_4)
              ], 8, _hoisted_3)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "recap-card",
                "aria-label": _ctx.$t('devis.modal.recap')
              }, [
                (_ctx.objet)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('dataList.devisObject')), 1),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.objet), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('dataList.devisId')), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('devisValidation.devisNumber')) + _toDisplayString(_ctx.id), 1)
                ]),
                (_ctx.formattedPrice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('dataList.devisPrice')), 1),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formattedPrice) + " HT", 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_8),
              (_ctx.isElectronicSigningPossible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.$t('devis.modal.command.choice.title')), 1),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["choice-card", { selected: _ctx.finalizationChoice === 'signature' }]),
                        role: "radio",
                        "aria-checked": _ctx.finalizationChoice === 'signature',
                        tabindex: "0",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectChoice('signature'))),
                        onKeydown: [
                          _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.selectChoice('signature')), ["prevent"]), ["space"])),
                          _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.selectChoice('signature')), ["prevent"]), ["enter"])),
                          _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.selectChoice('withoutSign')), ["prevent"]), ["down"])),
                          _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.selectChoice('signature')), ["prevent"]), ["up"]))
                        ]
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_RadioBox, {
                            selected: _ctx.finalizationChoice === 'signature'
                          }, null, 8, ["selected"])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('devis.modal.command.choice.sign.title')), 1),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('devis.modal.command.choice.sign.desc')), 1)
                        ])
                      ], 42, _hoisted_21),
                      _createElementVNode("div", {
                        class: _normalizeClass(["choice-card", { selected: _ctx.finalizationChoice === 'withoutSign' }]),
                        role: "radio",
                        "aria-checked": _ctx.finalizationChoice === 'withoutSign',
                        tabindex: "0",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectChoice('withoutSign'))),
                        onKeydown: [
                          _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.selectChoice('withoutSign')), ["prevent"]), ["space"])),
                          _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.selectChoice('withoutSign')), ["prevent"]), ["enter"])),
                          _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (_ctx.selectChoice('withoutSign')), ["prevent"]), ["down"])),
                          _cache[10] || (_cache[10] = _withKeys(_withModifiers(($event: any) => (_ctx.selectChoice('signature')), ["prevent"]), ["up"]))
                        ]
                      }, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_RadioBox, {
                            selected: _ctx.finalizationChoice === 'withoutSign'
                          }, null, 8, ["selected"])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('devis.modal.command.choice.withoutSign.title')), 1),
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('devis.modal.command.choice.withoutSign.desc')), 1)
                        ])
                      ], 42, _hoisted_26)
                    ]),
                    (_ctx.finalizationChoice === 'signature')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.$t('devis.modal.command.sign.title')), 1),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("label", _hoisted_35, [
                                _createTextVNode(_toDisplayString(_ctx.$t('label.lastname')) + " ", 1),
                                _cache[23] || (_cache[23] = _createElementVNode("span", {
                                  class: "required-mention",
                                  "aria-hidden": "true"
                                }, "*", -1))
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                id: "signatory-lastname",
                                type: "text",
                                class: _normalizeClass(["custom-text-input", { 'input-error': _ctx.attemptedSubmit && _ctx.lastnameError }]),
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.lastname) = $event)),
                                onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.validateLastname && _ctx.validateLastname(...args))),
                                disabled: _ctx.isLoading,
                                required: "",
                                "aria-required": "true",
                                "aria-invalid": _ctx.attemptedSubmit && !!_ctx.lastnameError,
                                "aria-describedby": _ctx.attemptedSubmit && _ctx.lastnameError ? 'signatory-lastname-error' : undefined
                              }, null, 42, _hoisted_36), [
                                [_vModelText, _ctx.lastname]
                              ]),
                              (_ctx.attemptedSubmit && _ctx.lastnameError)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.lastnameError), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("label", _hoisted_39, [
                                _createTextVNode(_toDisplayString(_ctx.$t('label.firstname')) + " ", 1),
                                _cache[24] || (_cache[24] = _createElementVNode("span", {
                                  class: "required-mention",
                                  "aria-hidden": "true"
                                }, "*", -1))
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                id: "signatory-firstname",
                                type: "text",
                                class: _normalizeClass(["custom-text-input", { 'input-error': _ctx.attemptedSubmit && _ctx.firstnameError }]),
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.firstname) = $event)),
                                onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.validateFirstname && _ctx.validateFirstname(...args))),
                                disabled: _ctx.isLoading,
                                required: "",
                                "aria-required": "true",
                                "aria-invalid": _ctx.attemptedSubmit && !!_ctx.firstnameError,
                                "aria-describedby": _ctx.attemptedSubmit && _ctx.firstnameError ? 'signatory-firstname-error' : undefined
                              }, null, 42, _hoisted_40), [
                                [_vModelText, _ctx.firstname]
                              ]),
                              (_ctx.attemptedSubmit && _ctx.firstnameError)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.firstnameError), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("label", _hoisted_43, [
                                _createTextVNode(_toDisplayString(_ctx.$t('label.email')) + " ", 1),
                                _cache[25] || (_cache[25] = _createElementVNode("span", {
                                  class: "required-mention",
                                  "aria-hidden": "true"
                                }, "*", -1))
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                id: "signatory-email",
                                type: "email",
                                class: _normalizeClass(["custom-text-input", { 'input-error': _ctx.attemptedSubmit && _ctx.emailError }]),
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.email) = $event)),
                                onInput: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args))),
                                disabled: _ctx.isLoading,
                                required: "",
                                "aria-required": "true",
                                "aria-invalid": _ctx.attemptedSubmit && !!_ctx.emailError,
                                "aria-describedby": _ctx.attemptedSubmit && _ctx.emailError ? 'signatory-email-error' : 'signatory-email-help'
                              }, null, 42, _hoisted_44), [
                                [_vModelText, _ctx.email]
                              ]),
                              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('devis.modal.command.sign.emailHelp')), 1),
                              (_ctx.attemptedSubmit && _ctx.emailError)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.emailError), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isSignChoice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("label", _hoisted_50, [
                          _createTextVNode(_toDisplayString(_ctx.$t('devis.modal.command.numero.commande')) + " ", 1),
                          _createElementVNode("span", _hoisted_51, "(" + _toDisplayString(_ctx.$t('devis.modal.command.optional')) + ")", 1)
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          id: "numero-commande-input",
                          type: "text",
                          class: "custom-text-input",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.numeroCommande) = $event)),
                          placeholder: _ctx.$t('devis.modal.command.numero.commande'),
                          disabled: _ctx.isLoading
                        }, null, 8, _hoisted_52), [
                          [_vModelText, _ctx.numeroCommande]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("span", _hoisted_54, [
                          _createTextVNode(_toDisplayString(_ctx.$t('devis.modal.command.bonCommande.label')) + " ", 1),
                          _createElementVNode("span", _hoisted_55, "(" + _toDisplayString(_ctx.$t('devis.modal.command.optional')) + ")", 1)
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("input", {
                            ref: "fileInputRef",
                            id: "bon-commande-file-input",
                            type: "file",
                            class: "hidden-file-input",
                            accept: ".pdf,application/pdf",
                            onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                            disabled: _ctx.isLoading,
                            "aria-labelledby": "bon-commande-label",
                            "aria-invalid": !!_ctx.fileError,
                            "aria-describedby": _ctx.fileError ? 'bon-commande-error' : undefined
                          }, null, 40, _hoisted_57),
                          (!_ctx.currentFile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn-add-file",
                                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args))),
                                  disabled: _ctx.isLoading
                                }, [
                                  _createElementVNode("img", {
                                    src: _ctx.clipIcon,
                                    class: "clip-icon",
                                    alt: "",
                                    "aria-hidden": "true"
                                  }, null, 8, _hoisted_60),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('devis.modal.command.bonCommande.add')), 1)
                                ], 8, _hoisted_59)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                _createVNode(_component_RemovableItem, {
                                  title: _ctx.currentFile.name,
                                  onRemove: _ctx.removeFile
                                }, null, 8, ["title", "onRemove"])
                              ]))
                        ]),
                        (_ctx.fileError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.fileError), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.$t('devis.modal.command.withoutSign.confirmText')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-action btn-cancel",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
                disabled: _ctx.isLoading
              }, _toDisplayString(_ctx.$t('devis.modal.command.btn.cancel')), 9, _hoisted_65),
              _createElementVNode("button", {
                type: "button",
                class: "btn-action btn-primary",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.handlePrimaryAction && _ctx.handlePrimaryAction(...args))),
                disabled: _ctx.isLoading || (_ctx.attemptedSubmit && _ctx.isSignChoice && !_ctx.isSignFormValid)
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_67))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.primaryButtonLabel), 1)
              ], 8, _hoisted_66)
            ])
          ], 544)
        ]),
        _: 1
      }, 8, ["onCancel"]))
    : _createCommentVNode("", true)
}